<template>
  <div class="elencotipocomponenteedit">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Modifica una tipologia di componente</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="nome" v-model="formData.componente.nome" type="text" :state="state.nome" placeholder="Nome della tipologia di componente" /><label for="nome">Nome *</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-select class="slide-up" id="idCategoria" v-model="formData.componente.idCategoria" :options="option.categoria" :state="state.idCategoria" placeholder="Categoria del componente" /><label for="idCategoria">Categoria *</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.componente.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="updateTipocomponente()"><font-awesome-icon icon="marker" /> Aggiorna</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'elencotipocomponenteedit',
  data() {
    return {
      option: {
        categoria: []
      },
      state: {
        nome: null,
        idCategoria: null,
        note: null
      },
      formData:{
        componente: {
          nome: '',
          idCategoria: null,
          note: ''
        }
      }
    }
  },
  created: function(){
    this.option.categoria = this.getListOption("categoriacomponente")
    this.loadTipocomponente()
  },
  methods: {
    updateTipocomponente(){
      Vue.http.post('elenco/tipocomponente/update/'+this.$route.params.id, this.formData, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Tipologia di componente aggiornata con successo!',
            type: 'success'
          })
          this.$router.push('/elenco/tipocomponente')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la modifica',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    loadTipocomponente(){
      Vue.http.post('elenco/tipocomponente/load/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData = response.body.data
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    },
    getListOption(tipo){
      var list = []

      Vue.http.post('selectlist/'+tipo, {}, {credentials : true}).then(response => {
        if(response.body.success){
            for(var i=0; i<response.body.list.length; i++){
              if(response.body.list[i].codice)
                list.push({value: response.body.list[i].id, text: response.body.list[i].codice+" - "+response.body.list[i].nome})
              else
                list.push({value: response.body.list[i].id, text: response.body.list[i].nome})
            }
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista "+tipo+" non caricata correttamente.",
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Lista "+tipo+" non caricata correttamente.",
            type: 'error'
        })
      })

      return list
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>

<style scoped>
#nome{
  text-indent: 85px;
}

#idCategoria{
  text-indent: 110px;
}

#sitoweb{
  text-indent: 100px;
}

#note{
  text-indent: 60px;
  line-height: 1.8;
}
</style>